import { render } from "./ArrowBoxDownIcon.vue?vue&type=template&id=f0ffb68a"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__